/* eslint-disable no-restricted-imports */
import {
  useDispatch as useReduxDispatch,
  useSelector as useReduxSelector,
} from 'react-redux';
import {
  createSelector as reduxCreateSelector,
  Selector,
} from '@reduxjs/toolkit';
import type { AppDispatch, RootState } from './types';

// Recommended to use typed hooks in Redux docs
// https://react-redux.js.org/using-react-redux/usage-with-typescript#define-typed-hooks
export const useAppDispatch = useReduxDispatch.withTypes<AppDispatch>();
export const useAppSelector = useReduxSelector.withTypes<RootState>();

export const createAppSelector = <
  TSelector extends Selector<RootState, ReturnType<TSelector>>,
>(
  s: TSelector,
) => reduxCreateSelector((r: RootState) => r, s);
